var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.7em",
    height: "0.7em",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495 495",
    style: {
      enableBackground: "new 0 0 495 495"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDE55"
    },
    points: "434.477,227.821 478.869,178.66 414.058,164.981 381.022,107.57 381.022,266.658  441.496,293.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEB99"
    },
    points: "347.986,164.981 283.175,178.66 327.568,227.821 320.55,293.688 381.022,266.658  381.022,107.57  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB99"
    },
    d: "M288.544,458.73c-90.69-22.63-160.01-108.71-160.01-211.23s69.32-188.6,160.01-211.23 c30.19-7.54,59.89-8.18,87.48-3.08C339.614,12.12,297.374,0,252.284,0c-136.7,0-247.5,110.81-247.5,247.5s110.8,247.5,247.5,247.5 c45.09,0,87.33-12.12,123.74-33.19C348.434,466.91,318.734,466.27,288.544,458.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE55"
    },
    d: "M252.284,247.5c0-91.59,49.79-171.51,123.74-214.31c-27.59-5.1-57.29-4.46-87.48,3.08 c-90.69,22.63-160.01,108.71-160.01,211.23s69.32,188.6,160.01,211.23c30.19,7.54,59.89,8.18,87.48,3.08 C302.074,419.01,252.284,339.09,252.284,247.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDE55"
    },
    points: "490.216,342.579 457.992,335.777 441.565,307.228 441.566,386.332 471.637,399.771  468.144,367.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEB99"
    },
    points: "425.138,335.777 392.914,342.579 414.987,367.022 411.498,399.771 441.566,386.332  441.565,307.228  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.55fab090104ecfe712f8bc83b7ef5199.svg";
export { ForwardRef as ReactComponent };